import { MuiInput } from "../../components/basicComponent/MuiInput";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import React from "react";
import DownloadIcon from "@mui/icons-material/Download";

const PaymentCard = () => {
  return (
    <>
      <div className="grow">
        <SideMenu />
        <div className="wrapper flex grow flex-col">
          <Header />
          <main className="grow content" id="content" role="content">
            <div className="container-fixed">
              <div className="card-header mb-1 ">
                <h3 className="card-title titlecolorr">Payments</h3>
              </div>
              <div className="card">
                <div className="card-header bg-white border-0 dashboard-card-header">
                  <div className=" hotel-search-input d-flex  flex-sm-nowrap flex-wrap  me-4">
                    <MuiInput
                      // iconEnd={<SearchIcon />}
                      placeholder="All Methods"
                      className="me-2 mb-2 mb-sm-0"
                    />
                    <MuiInput
                      // iconEnd={<SearchIcon />}
                      placeholder="All Status"
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <button className="btn btn-light rounded-circle d-flex align-items-center justify-content-center me-2 header-back-button">
                      <DownloadIcon />
                    </button>
                  </div>
                </div>

                <div className="table-responsive">
                  <div className="scrollable-x-auto">
                    <table className="table table-bordered">
                      <thead className="thead-light">
                        <tr>
                          <th>Transaction Date </th>
                          <th>Customer</th>
                          <th>Product/Service</th>
                          <th>Payment Method</th>
                          <th>Status</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-muted">Feb 11, 10:56 AM</td>
                          <td className="text-muted">CSG TECHNOSOL</td>
                          <td className="text-muted">FLight Booking</td>
                          <td className="text-muted">Prepaid</td>
                          <td className="text-muted">Active</td>
                          <td className="text-muted">100000</td>
                        </tr>
                        <tr>
                          <td className="text-muted">Feb 11, 10:56 AM</td>
                          <td className="text-muted">CSG TECHNOSOL</td>
                          <td className="text-muted">FLight Booking</td>
                          <td className="text-muted">Prepaid</td>
                          <td className="text-muted">Active</td>
                          <td className="text-muted">100000</td>
                        </tr>
                        <tr>
                          <td className="text-muted">Feb 11, 10:56 AM</td>
                          <td className="text-muted">CSG TECHNOSOL</td>
                          <td className="text-muted">FLight Booking</td>
                          <td className="text-muted">Prepaid</td>
                          <td className="text-success fw-bold">Active</td>
                          <td className="text-muted">100000</td>
                        </tr>
                        <tr>
                          <td className="text-muted">Feb 11, 10:56 AM</td>
                          <td className="text-muted">CSG TECHNOSOL</td>
                          <td className="text-muted">FLight Booking</td>
                          <td className="text-muted">Prepaid</td>
                          <td className="text-muted">Active</td>
                          <td className="text-muted">100000</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default PaymentCard;
